import { RenderViewComponentType } from '@upright/common/renderer/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { bouToolCommonBoxPadding } from '@upright/ui/common/generic/layout/layout-constants';
import { RenderViewButton } from '@upright/ui/common/generic/misc/render-view-button';
import styled from 'styled-components';
import { useSdgAlignmentsContext } from './context';
import { sdgIconAndNameWidth, sdgAlignmentAreaWidth } from './shared';

export const SdgRenderViewButton = () => {
  const context = useSdgAlignmentsContext();
  return (
    <Root>
      <Left />
      <Right>
        <Half />
        <Divider />
        <Half>
          <RenderViewButton
            initialOptions={{
              release: context.release,
              version: context.version,
              showControlUi: true,
              componentParams: [
                {
                  componentType: RenderViewComponentType.SDG_ALIGNMENTS,
                  item: {
                    index: 0,
                    id: context.entityId,
                    type: context.entityType,
                    resultId: context.resultId,
                    name: context.entity?.name,
                  },
                  order: 0,
                  unitsMode: context.viewOptions.unitsMode,
                },
              ],
            }}
          />
        </Half>
      </Right>
    </Root>
  );
};

const Root = styled.div`
  ${bouToolCommonBoxPadding}
  border-top: 1px solid ${BouColor.TOOL_BORDER_LIGHTER_GRAY};
  width: 100%;
  display: flex;
  height: 50px;
`;

const Left = styled.div`
  ${sdgIconAndNameWidth}
`;

const Right = styled.div`
  ${sdgAlignmentAreaWidth}
  display: flex;
`;

const Half = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const Divider = styled.div`
  width: 1px;
  background-color: ${BouColor.TOOL_BORDER_DARK_GRAY};
`;
